﻿$.fn.dxCtrlDemandeConfigGmail = function custom_dxCtrlDemandeConfigGmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrldemandeconfiggmail dx-ctrl");
        this.createInstance(new cdxCtrlDemandeConfigGmail(this, option));
    }
    return this;
}

window.cdxCtrlDemandeConfigGmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var popup = null
    function mConstruit() {
        container.empty();

        popup = container.appendTo("body").dxCtrlPopupBase({
            fullScreen: false,
            showTitle: true,
            shading: true,
            showMaximize: false,
            showCloseButton: true,
            width: 600,
            height: "auto",
            maxHeight:"100%",
            title: "Configuration GMAIL",
            contentTemplate: function (contentElement) {
                contentElement.css("padding", "25px")
                mRempli(contentElement)
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    var inChangeCode = false
    function mRempli(contentElement) {
        var ds = [
            {
                //    id: 2,
                //    text: "Microsoft messenger",
                //    img: parametre.urldispatch + "/img/email/MicrosoftExchange.png",
                //    urlaide: "https://www.perplexity.ai/search/new?q=Comment créer un mot de passe d'application pour un email sur microsoft messenger",
                //    pop_switch: false,
                //    pwd_app: "",
                //    pop_serveur: "pop.aol.com",
                //    pop_port: "995",
                //    pop_ssl: true,
                //    smtp_serveur: "smtp.aol.com",
                //    smtp_port:465,
                //    smtp_ssl:true
                //},
                //{
                id: 3,
                text: "Gmail",
                img: parametre.urldispatch + "/img/email/google.png",
                pop_switch: true,
                pwd_app: "",
                pop_serveur: "pop.gmail.com",
                pop_port: "993",
                pop_ssl: true,
                smtp_serveur: "smtp.gmail.com",
                smtp_port: 465,
                smtp_ssl: true
            }, {
                id: 1,
                text: "iCloud",
                img: parametre.urldispatch + "/img/email/icloud.png",
                urlaide: "https://www.perplexity.ai/search/new?q=Comment créer un mot de passe d%27application pour un email sur icloud",
                pop_switch: false,
                pwd_app: "",
                pop_serveur: "imap.mail.me.com",
                pop_port: "995",
                pop_ssl: true,
                smtp_serveur: "smtp.mail.me.com",
                smtp_port: 587,
                smtp_ssl: true
            },
            {
                id: 4, text: "Yahoo",
                img: parametre.urldispatch + "/img/email/yahoo.png",
                urlaide: "https://www.perplexity.ai/search/new?q=Comment créer un mot de passe d%27application pour un email sur yahoo",
                pop_switch: false,
                pwd_app: "",
                pop_serveur: "pop.mail.yahoo.com",
                pop_port: "995",
                pop_ssl: true,
                smtp_serveur: "smtp.mail.yahoo.com",
                smtp_port: 465,
                smtp_ssl: true
            },
            {
                id: 5,
                text: "Aol",
                img: parametre.urldispatch + "/img/email/aol.png",
                urlaide: "https://www.perplexity.ai/search/new?q=Comment créer un mot de passe d%27application pour un email sur aol",
                pop_switch: false,
                pwd_app: "",
                pop_serveur: "pop.aol.com",
                pop_port: "995",
                pop_ssl: true,
                smtp_serveur: "smtp.aol.com",
                smtp_port: 465,
                smtp_ssl: true
            },
            {
                id: 6,
                text: "Outlook",
                img: parametre.urldispatch + "/img/email/outlook.png",
                urlaide: "https://www.perplexity.ai/search/new?q=Comment créer un mot de passe d%27application pour un email sur outlook",
                pop_switch: false,
                pwd_app: "",
                pop_serveur: "outlook.office365.com",
                pop_port: "995",
                pop_ssl: true,
                smtp_serveur: "smtp-mail.outlook.com",
                smtp_port: 587,
                smtp_ssl: true
            },
            { id: 7 }]
        var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
        $("<div/>").appendTo(dxScroll.content()).dxAccordion({
            dataSource: ds,
            itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css({ "align-items": "center", "justify-content": "center" })
                switch (itemData.id) {
                    case 7:
                        itemElement.html("Autre domaine")
                        break;
                    default:
                        $("<img style='height:35px;display:inline-block' src='" + itemData.img + "'/>").appendTo(itemElement)
                        break;
                }
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                switch (itemData.id) {
                    case 7:
                        popup.hide()
                        break;
                    case 3:
                        mRempliGmail(itemElement,itemData)
                        break;
                    default:
                        mRempliAutre(itemElement, itemData)
                        break;
                }
            }
        })


        var $Div = $("<div style='padding-top:20px;text-align:center;'>").appendTo(dxScroll.content())
        var $A2 = $("<a href='javascript:void(0)' >Vous n'arrivez pas à configurer votre compte email, faite une demande support</a>").appendTo($Div)
        $A2.on("click", function (e) {
            popup.hide()
            option.onDemandeClosePopupParent()
            page.dxMenuLeft.mShowSupport(true)
            window.setTimeout(function () {
                mNotify("Vous rencontrez un problème pour configurer votre compte email.<br/>Précisez nous vos difficultés en nous donnant l'adresse email en question et toutes les informations dont vous disposez.<br/>Nous vous donnerons une solution rapidement.", "success", 20000)
            }, 2000)
        })
    }

    function mRempliGmail(itemElement,itemData) {
        option.bddCtrl.mAjaxCall({
            command: "getemail_gmail_enregistre"
        }, function (data) {
            if (typeof data.lstemail != 'undefined' && data.lstemail.filter(function (o) {
                return o.adresse_gmail_enregistre == option.adresseEmail
            }).length > 0) {
                popup.hide()
                option.onDemandeConnexionOauthGmail()
            } else {
                $("<div style='font-size:140%;'>Pour connecter un compte gmail (ou hébergé chez gmail) à " + parametre.nom + ", vous devez créer un mot de passe d'application pour " + parametre.nom + " dans votre compte gmail<br/><br/></div>").appendTo(itemElement)

                //var $Td = $("<td style='width:100%;'></td>").appendTo($Tr)
                $("<div>Pour savoir comment créer un mot de passe Gmail, vous pouvez visiter <a href='https://support.google.com/mail/answer/185833?hl=fr' target='_blank'>la page d'aide google</a> ou demander à <a href='https://www.perplexity.ai/search/new?q=Comment%20d%C3%A9finir%20un%20mot%20de%20passe%20d%27application%20pour%20une%20adresse%20gmail' target='_blank'>l'IA comment faire</a>.</div>").appendTo(itemElement)
                $("<div style='padding-top:5px;'>Si votre navigateur est connecté au compte Gmail que vous voulez utiliser, vous pouvez accéder directement à <a href='https://myaccount.google.com/apppasswords' target='_blank'>la page de création de mot de passe d'application de votre compte Gmail</a> (Sous réserve que votre compte gmail soit <a href='https://support.google.com/mail/answer/185833?hl=fr' target='_blank'>correctement configuré</a> pour les mots de passe d'application).</div>").appendTo(itemElement)
                $("<div style='padding:10px 10px 0 10px;'>Une fois que vous avez créé votre mot de passe d'application (ou si vous en avez déjà un), il vous suffit de le saisir ci-dessous.</div>").appendTo(itemElement)

                $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%'></td>").appendTo($Tr)
                var dxCtrlTxtPwd = $("<div style='margin:5px'/>").appendTo($Td).dxCtrlTextBox({
                    label: "Mot de passe d'application",
                    labelMode: 'floating',
                    placeholder: "...",
                    value: "",
                    buttons: [{
                        focusStateEnabled: false,
                        name: 'showpwd',
                        location: 'after',
                        options: {
                            icon: 'eyeopen',
                            hint: "Révéler/cacher le texte",
                            focusStateEnabled: false,
                            stylingMode: 'text',
                            onClick() {
                                if (dxCtrlTxtPwd.element().find("input").hasClass("txtPassword")) {
                                    dxCtrlTxtPwd.element().find("input").removeClass("txtPassword")
                                } else {
                                    dxCtrlTxtPwd.element().find("input").addClass("txtPassword")
                                }
                            },
                        },
                    }],
                    onValueChanged: function (e) {
                    },
                    onContentReady: function (e) {
                        e.component.element().find("input").addClass("txtPassword")
                    }
                }).dxCtrlTextBox("instance")
                var $Td = $("<td style='width:1px'></td>").appendTo($Tr)
                var $btArrowEmail = $("<div class='allowcontextmenu' style='display:inline-block;padding-left:5px;'/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-arrow-right",
                    height: 45,
                    width: 45,
                    onClick: function (e) {
                        if (dxCtrlTxtPwd.option("value") == null || dxCtrlTxtPwd.option("value").length == 0) {
                            mNotify("Veuillez saisir le mot de passe d'application de votre compte gmail.", "warning", 6000)
                            dxCtrlTxtPwd.focus()
                            return;
                        }
                        popup.hide()
                        itemData.pwd_app = dxCtrlTxtPwd.option("value")
                        itemData.adresse_email = option.adresseEmail
                        option.onValidPwd(itemData)
                    }
                }).dxCtrlButton("instance");

                ////var $Table = $("<table style='padding-top:20px'/>").appendTo(contentElement)
                ////var $Tr = $("<tr/>").appendTo($Table)
                ////var $Td = $("<td style='width:50%'></td>").appendTo($Tr)
                ////var $A1 = $("<a href='javascript:void(0)'>L'adresse gmail est déjà enregistrée<br/>auprés de " + parametre.nom + "</a>").appendTo($Td)
                ////$A1.on("click", function (e) {
                ////        popup.hide()
                ////        option.onDemandeClosePopupParent()
                ////        option.onDemandeCnxOauthGmail()
                ////})
                //////$("<div/>").appendTo($Td).dxCtrlButton({
                //////    html: "L'adresse gmail est déjà enregistrée<br/>auprés de " + parametre.nom,
                //////    onClick: function (e) {
                //////        popup.hide()
                //////        option.onDemandeClosePopupParent()
                //////        option.onDemandeCnxOauthGmail()
                //////    }
                //////}).dxCtrlButton("instance");
                ////var $Td = $("<td style='width:50%'></td>").appendTo($Tr)
                ////var $A2 = $("<a href='javascript:void(0)' >Je n'arrive pas a créer un mot de passe d'application avec mon compte Gmail, faire une demande support</a>").appendTo($Td)
                ////$A2.on("click", function (e) {
                ////    popup.hide()
                ////    option.onDemandeClosePopupParent()
                ////    page.dxMenuLeft.mShowSupport(true)
                ////    window.setTimeout(function () {
                ////        mNotify("Vous rencontrez un problème pour créer votre mot de passe d'application avec votre compte Gmail.<br/>Précisez nous vos difficultés en nous donnant l'adresse email en question.<br/>Nous vous donnerons une solution rapidement.", "success", 20000)
                ////    }, 2000)
                ////})
                //var $Div = $("<div style='padding-top:20px;'>").appendTo(itemElement)
                //var $A2 = $("<a href='javascript:void(0)' >Je n'arrive pas a créer un mot de passe d'application avec mon compte Gmail, faire une demande support</a>").appendTo($Div)
                //$A2.on("click", function (e) {
                //    popup.hide()
                //    option.onDemandeClosePopupParent()
                //    page.dxMenuLeft.mShowSupport(true)
                //    window.setTimeout(function () {
                //        mNotify("Vous rencontrez un problème pour créer votre mot de passe d'application avec votre compte Gmail.<br/>Précisez nous vos difficultés en nous donnant l'adresse email en question.<br/>Nous vous donnerons une solution rapidement.", "success", 20000)
                //    }, 2000)
                //})

            }
        })
    }

    function mRempliAutre(itemElement, itemData) {
        $("<div style='font-size:140%;'>Pour connecter un compte <b>" + itemData.text + "</b> à " + parametre.nom + ", vous devez créer un mot de passe d'application pour " + parametre.nom + " dans votre compte <b>" + itemData.text + "</b><br/><br/></div>").appendTo(itemElement)

        $("<div>Pour savoir comment créer un mot de passe d'application <b>" + itemData.text + "</b>, vous pouvez consulter <a href='" + itemData.urlaide + "' target='_blank'>cette page d'aide</a> qui vous explique comment créer ce mot de passe d'application.</div>").appendTo(itemElement)
        $("<div style='padding:10px 10px 0 10px;'>Une fois que vous avez créé votre mot de passe d'application (ou si vous en avez déjà un), il vous suffit de le saisir ci-dessous.</div>").appendTo(itemElement)

        $Table = $("<table/>").appendTo(itemElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'></td>").appendTo($Tr)
        var dxCtrlTxtPwd = $("<div style='margin:5px'/>").appendTo($Td).dxCtrlTextBox({
            label: "Mot de passe d'application",
            labelMode: 'floating',
            placeholder: "...",
            value: "",
            buttons: [{
                focusStateEnabled: false,
                name: 'showpwd',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    hint: "Révéler/cacher le texte",
                    focusStateEnabled: false,
                    stylingMode: 'text',
                    onClick() {
                        if (dxCtrlTxtPwd.element().find("input").hasClass("txtPassword")) {
                            dxCtrlTxtPwd.element().find("input").removeClass("txtPassword")
                        } else {
                            dxCtrlTxtPwd.element().find("input").addClass("txtPassword")
                        }
                    },
                },
            }],
            onValueChanged: function (e) {
            },
            onContentReady: function (e) {
                e.component.element().find("input").addClass("txtPassword")
            }
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:1px'></td>").appendTo($Tr)
        var $btArrowEmail = $("<div class='allowcontextmenu' style='display:inline-block;padding-left:5px;'/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-arrow-right",
            height: 45,
            width: 45,
            onClick: function (e) {
                if (dxCtrlTxtPwd.option("value") == null || dxCtrlTxtPwd.option("value").length == 0) {
                    mNotify("Veuillez saisir le mot de passe d'application de votre compte gmail.", "warning", 6000)
                    dxCtrlTxtPwd.focus()
                    return;
                }
                popup.hide()
                itemData.pwd_app = dxCtrlTxtPwd.option("value")
                itemData.adresse_email = option.adresseEmail
                option.onValidPwd(itemData)
            }
        }).dxCtrlButton("instance");
    }

    this.element = function () { return container }

    mConstruit();
}